/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Box, Typography, Paper } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import FiberNewIcon from "@mui/icons-material/FiberNew";

import * as Actions from "actions";
import { isFeatureSupported } from "helpers/utils";

import ShopProductSearch from "components/widgets/user/ShopProductSearch";
import ShopProductPopularSlider from "components/elements/user/products/ShopProductPopularSlider";
import ShopProductNewSlider from "components/elements/user/products/ShopProductNewSlider";
import ShopProductsList from "components/elements/user/products/ShopProductList";
import StoriesPlayer from "components/StoriesPlayer/StoriesPlayer";
import UnifiedSwipeTrigger from "components/elements/main/UnifiedSwipeTrigger";
import CustomFlexBox from "components/CustomFlexBox";
import { Button } from "components/Atoms";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import ReorderIcon from '@mui/icons-material/Reorder';

const ShopHomeTabContent = (props) => {
    const [displayModeState, setDisplayModeState] = useState("MAIN");
    const [childData, setChildData] = useState('');

    const {
        shopId, history, shopinfo, userMainAddStoreToFavlist
    } = props;

    const { collections, logo } = shopinfo;

    const handleDataFromChild = (data) => {
        setChildData(data);
    };

    useEffect(() => {
        props.userResetSearchProducts();
    }, []);

    const handleAddShopToWishlist = (favId) => {
        userMainAddStoreToFavlist(favId);
    };

    const handleBack = () => {
        history.goBack();
    };

    // Prepare stories data
    let shopStoryData = [];
    let stories = [];

    if (collections && collections.length > 0) {
        collections.map((item) => {
            stories.push({
                video: item.cdn.secure_url,
            });
        });
    }

    shopStoryData.push({
        user: {
            avatar: logo && logo[0] && logo[0].cdn.secure_url,
            name: "Latest Collection",
            userLink: ""
        },
        stories: stories,
        favId: shopId,
    });

    const handleResetResultsStory = () => {
        setDisplayModeState("MAIN");
    };

    const renderResultsAsStories = () => (
        <div>
            <StoriesPlayer
                storiesData={shopStoryData}
                onCancel={() => handleResetResultsStory()}
                setAsFav={handleAddShopToWishlist}
            />
        </div>
    );

    const renderMainContent = () => (
        <Box sx={{ pb: 2 }}>

            {/* Popular Products Section */}
            <Box sx={{ mb: 4 }}>
                <ShopProductPopularSlider shopId={shopId} includeHeader={true} />
            </Box>

            {/* New Arrivals Section */}
            <Box sx={{ mb: 4 }}>
                <ShopProductNewSlider shopId={shopId} includeHeader={true} />
            </Box>

            {/* All Products */}
            <Box sx={{ mb: 4 }}>
                <ShopProductsList shopId={shopId} includeHeader={true} />
            </Box>




            {/* Stories Button - Hidden for now to match Flutter design */}
            {false && isFeatureSupported("shopreels") && collections && collections.length > 0 && (
                <CustomFlexBox sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    position: 'fixed',
                    width: '100%',
                    bottom: 150, // Adjusted for bottom tabs
                    justifyContent: 'center',
                    zIndex: 'modal'
                }}>
                    <Button
                        sx={{ marginRight: '2px', marginLeft: '4px' }}
                        size="large"
                        color="primary"
                        variant="contained"
                        onClick={() => setDisplayModeState("STORIES")}
                    >
                        <SlideshowIcon /> &nbsp; Latest Collection
                    </Button>
                </CustomFlexBox>
            )}

        </Box>
    );

    const renderDisplayMode = (displayMode) => {
        switch (displayMode) {
            case "STORIES":
                return renderResultsAsStories();
            case "MAIN":
            default:
                return renderMainContent();
        }
    };

    return (
        <>
            { renderDisplayMode(displayModeState) }
            <UnifiedSwipeTrigger onLeftSwipeComplete={() => { handleBack() }} />
        </>
    );

};

ShopHomeTabContent.propTypes = {
    userResetSearchProducts: PropTypes.func.isRequired,
    shopId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    shopinfo: PropTypes.object.isRequired,
    userMainAddStoreToFavlist: PropTypes.func.isRequired,
};

const _ShopHomeTabContent = connect(
    ({ userproducts, bootupInfo }) => ({
        bootupInfo,
        shopinfo: bootupInfo.shopinfo,
        reqStatus: userproducts.reqStatus,
        isLoading: userproducts.isLoading,
        serviceError: userproducts.serviceError,
        categoryList: userproducts.categoryList,
    }),
    (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopHomeTabContent);

export { _ShopHomeTabContent as default };
